import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { CommonModule } from '@angular/common';
import { MatFormField } from "@angular/material/input";
import { MatDividerModule } from '@angular/material/divider'; 
import { MatSelectModule } from '@angular/material/select';
import { Router, RouterLink } from '@angular/router';

import { Recepciones } from '../../Recepciones/models/recepciones';
import { RecepcionCarroceria } from '../../Recepciones/models/recepcion-carroceria';
import { RecepcionesService } from '../../Service/recepciones-service';

import { ToastService } from '../../Service/toast-service'; 

@Component({
  selector: 'app-recepciones-add',
  standalone: true,
  imports: [
    FormsModule, ReactiveFormsModule, CommonModule, 
    MatFormField, MatDividerModule, MatSelectModule, RouterLink
  ],
  templateUrl: './recepciones-add.html',
  styleUrl: './recepciones-add.css',
})
export class RecepcionesAdd implements OnInit {
  ordenForm!: FormGroup;
  
  clientes: any[] = []; // Ahora cada objeto contiene { an8: number, name: string }
  unidades: any[] = []; // Listado dinámico de vehículos filtrados por AN8
  asesores: any[] = [];
  archivosSeleccionados: File[] = [];
  pinesCarroceria: RecepcionCarroceria[] = [];

  // =========================================================================
  // 🌟 AQUÍ EXACTAMENTE SE DECLARAN LAS DOS NUEVAS PROPIEDADES:
  // =========================================================================
  
  // 1. Imagen actual del croquis (Inicia por default en Sedán)
  currentVehicleSvg: string = 'images/croquis-sedan.svg';

  // 2. Diccionario para traducir el STRVALUE2 de tu DB al nombre exacto del archivo SVG
  private mapperCarroceria: { [key: string]: string } = {
    'Sedán': 'sedan',
    'Pickup': 'pickup',
    'SUV': 'suv',
    'Camión': 'camion',
    'Autobús': 'autobus'
  };

  @ViewChild('selectCliente') selectCliente!: ElementRef<HTMLSelectElement>;
  @ViewChild('selectVehiculo') selectVehiculo!: ElementRef<HTMLSelectElement>;
  @ViewChild('selectAsesor') selectAsesor!: ElementRef<HTMLSelectElement>;

  mostrarMenuFlotante = false;
  coordenadasTemporales = { x: 0, y: 0 }; 
  posicionPantallaMenu = { left: 0, top: 0 }; 
  comentarioTemporal = '';
  tipoTallerActivo: string = 'AMBOS'; // Almacenará 'MECANICO', 'LAMINADO' o 'AMBOS'

  constructor(
      private recepcionesService: RecepcionesService,
      private fb: FormBuilder,
      private cdr: ChangeDetectorRef,
      public toastService: ToastService, // 🌟 REVISAR: Debe ser estrictamente 'public' 
      private router: Router // 🚀 INYECTADO
  ){ }

  ngOnInit(): void {
    this.ordenForm = this.fb.group({
      id: [null],
      folio: [{ value: 'Cargando...', disabled: true }], 
      fecha_entrada: [{ value: this.getFechaActual(), disabled: true }, Validators.required],

      // =========================================================================
      // REFACTORIZACIÓN EN SUB-OBJETOS: MATCH PERFECTO CON HIBERNATE / JACKSON
      // =========================================================================
      customer: this.fb.group({
        an8: [null, Validators.required] // Control reactivo para la llave de negocio
      }),
      unidad: this.fb.group({
        id: [{ value: null, disabled: true }, Validators.required] // Control reactivo para el vehículo
      }),

      kilometraje: [null, [Validators.required, Validators.min(0)]],
      nivelCombustible: ['', Validators.required], 
      id_asesor: [null, [Validators.required, Validators.min(1)]],
      observaciones_generales: [''],
      tipoSilueta: ['Sedán'], 

      // 🌟 NUEVO CONTROL DE MODALIDAD DE COSTO
      modalidadCosto: ['GRATIS', Validators.required], 
      costoMonto: [null], // Aquí se guardará el número capturado

      // FormArrays dinámicos
      detalles: this.fb.array([this.crearLinea()]),
      sintomas: this.fb.array([this.crearLineaSintoma()]) 
    });     

    this.cargarSiguienteFolio(); 
    this.cargarClientes(); 
    this.cargarAsesores(); 
    this.cargarGiro(); 
  }

  cargarAsesores(): void {
    this.recepcionesService.getAsesoresActivos().subscribe({
      next: (data) => {
        this.asesores = data;
        this.cdr.detectChanges(); 
      },
      error: (err) => console.error('Error al cargar asesores', err)
    });
  }

  cargarGiro(): void {
    this.recepcionesService.getGiroTaller().subscribe({
      next: (giro) => {
        this.tipoTallerActivo = giro ? giro.trim().toUpperCase() : 'AMBOS';
        console.log('⚙️ [TELEMETRÍA UDC] Giro de sucursal detectado en rampa:', this.tipoTallerActivo);
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('❌ Error al deducir el giro de la sucursal mediante UDC:', err);
        this.tipoTallerActivo = 'AMBOS'; // Salvaguarda en caso de caída de red
      }
    });    
  }

  onAsesorSeleccionado(event: any): void {
    const idAsesorValue = event.target.value;
    if (!idAsesorValue || idAsesorValue.trim() === "") {
      this.ordenForm.get('id_asesor')?.setValue(null); 
    } else {
      this.ordenForm.patchValue({ id_asesor: parseInt(idAsesorValue, 10) });
    }
  }

  cargarSiguienteFolio(): void {
    this.recepcionesService.getFolioTentativo().subscribe({
      next: (folio) => {
        this.ordenForm.patchValue({ folio: folio });
      },
      error: (err) => {
        console.error('No se pudo obtener el folio tentativo', err);
        this.ordenForm.patchValue({ folio: 'ERROR_FOLIO' });
      }
    });
  }

  cargarClientes(): void {
    this.recepcionesService.getClientesActivos().subscribe({
      next: (data) => {
        this.clientes = data; // Recibe la proyección DTO de Spring Boot: { an8, name }
      },
      error: (err) => console.error('Error al cargar catálogo de clientes', err)
    });
  }

  // =========================================================================
  // ESCUCHADOR CORE REFACTORIZADO (ELIMINA EL .FIND() OBSOLETO)
  // =========================================================================
  onClienteSeleccionado(event: any): void {
    const an8SeleccionadoRaw = event.target.value;
    
    // Acceso directo a los controles anidados utilizando sintaxis por caminos de Angular
    const an8Control = this.ordenForm.get('customer.an8');
    const idVehiculoControl = this.ordenForm.get('unidad.id');

    // Reset total preventivo de cascadas
    this.unidades = [];
    an8Control?.setValue(null);
    idVehiculoControl?.setValue(null);
    idVehiculoControl?.disable(); 

    if (an8SeleccionadoRaw) {
      // Convertimos el string del HTML a un entero nativo puro de 8 dígitos
      const an8Entero = parseInt(an8SeleccionadoRaw, 10);
      
      // Inyectamos el valor directamente en el sub-objeto reactivo
      an8Control?.setValue(an8Entero);
      console.log('AN8 Corporativo JDE inyectado al payload:', an8Entero);

      // Despachamos la consulta al servicio enviando el número entero indexado
      this.recepcionesService.getUnidadesPorCliente(an8Entero).subscribe({
        next: (data) => {
          this.unidades = data; // Recibe [{ id: 1, descripcion: 'Sentra - XYZ123' }]
          if (this.unidades.length > 0) {
            idVehiculoControl?.enable(); // Desbloqueamos el select de autos de forma reactiva
          }
          this.cdr.detectChanges(); 
        },
        error: (err) => console.error('Error al consultar unidades indexadas por AN8', err)
      });
    } 
  }

  onVehiculoSeleccionado(event: any): void {
    const idVehiculoValue = event.target.value;
    if (idVehiculoValue) {
      const idNum = parseInt(idVehiculoValue, 10);
      this.ordenForm.patchValue({ id_vehiculo: idNum });
      if (this.ordenForm.get('unidad.id')) {
        this.ordenForm.get('unidad.id')?.setValue(idNum);
      }

      // 🚗 CONTROL DINÁMICO AUTOMÁTICO (Sincronizado con UDC)
      const vehiculoSeleccionado = this.unidades.find(u => u.id === idNum);
      if (vehiculoSeleccionado && vehiculoSeleccionado.tipoCarroceria) {
        const tipoDb = vehiculoSeleccionado.tipoCarroceria; // Traerá "Sedán", "Pickup", etc.
        const nombreArchivo = this.mapperCarroceria[tipoDb] || 'sedan';
        
        this.currentVehicleSvg = `images/croquis-${nombreArchivo}.svg`;
        
        // 🟢 SELLA EL CAMBIO AUTOMÁTICO EN EL FORMULARIO
        this.ordenForm.get('tipoSilueta')?.setValue(tipoDb);
        console.log(`Carrocería JDE detectada: ${tipoDb}. Sincronizando control reactivo.`);
      }
    }
  }


  onCambioManualCarroceria(event: any): void {
    const siluetaSeleccionada = event.target.value; // Traerá "Sedán", "Pickup", "SUV", etc.
    if (siluetaSeleccionada) {
      const nombreArchivo = this.mapperCarroceria[siluetaSeleccionada] || 'sedan';
      this.currentVehicleSvg = `images/croquis-${nombreArchivo}.svg`;
      
      // 🟢 SELLA EL CAMBIO MANUAL EN EL FORMULARIO
      this.ordenForm.get('tipoSilueta')?.setValue(siluetaSeleccionada);
      console.log('🎯 [SaaS Alta] Silueta modificada manualmente a:', siluetaSeleccionada);
    }
  }
  
  getFechaActual(): string {
    const hoy = new Date();
    const anio = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, '0');
    const dia = String(hoy.getDate()).padStart(2, '0');
    const horas = String(hoy.getHours()).padStart(2, '0');
    const minutos = String(hoy.getMinutes()).padStart(2, '0');
    
    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  }

  get detalles(): FormArray {
    return this.ordenForm.get('detalles') as FormArray;
  }
  
  // (Nota: Deja aquí tus métodos crearLinea() y crearLineaSintoma() intactos)
  // =========================================================================
  // CONTROL DE LÍNEAS DE DETALLE (FORM_ARRAY)
  // =========================================================================
  /**
   * Estructura base para un nuevo renglón de inventario o inspección visual.
   */
  crearLinea(): FormGroup {
    return this.fb.group({
      id: [null],
      item_nombre: ['', Validators.required], // Evita guardar renglones vacíos
      estado: ['', Validators.required],      // Sincronizado con el Enum del backend
      cantidad: [1, [Validators.required, Validators.min(1)]],
      comentario_especifico: ['']
    });
  }

  agregarLinea(): void {
    this.detalles.push(this.crearLinea());
  }

  removerLinea(index: number): void {
    if (this.detalles.length > 1) {
      this.detalles.removeAt(index);
    }
  }

  // =========================================================================
  // CONTROL DE SÍNTOMAS / QUEJAS (FORM_ARRAY)
  // =========================================================================
  get sintomas(): FormArray {
    return this.ordenForm.get('sintomas') as FormArray;
  }

  crearLineaSintoma(): FormGroup {
    return this.fb.group({
      id: [null],
      descripcion_falla: ['', Validators.required] // Obligatorio para evitar fallas vacías
    });
  }

  agregarSintoma(): void {
    this.sintomas.push(this.crearLineaSintoma());
  }

  removerSintoma(index: number): void {
    if (this.sintomas.length > 1) {
      this.sintomas.removeAt(index);
    }
  }

  // =========================================================================
  // GESTIÓN DE ARCHIVOS FÍSICOS (FOTOS VEHICULARES)
  // =========================================================================
  onFilesSelected(event: any): void {
    const files: FileList = event.target.files;
    this.archivosSeleccionados = []; // Resetea la selección previa en memoria
    if (files) {
      for (let i = 0; i < files.length; i++) {
        this.archivosSeleccionados.push(files[i]);
      }
    }
  }

  // =========================================================================
  // TRANSACCIONALIDAD TOTAL: DISPACHO DE ORDEN HACIA BACKEND
  // =========================================================================
  guardarOrden(): void {
    // 🌟 1. CAPTURA DE VALORES INICIALES
      const modalidad = this.ordenForm.get('modalidadCosto')?.value;
      const monto = this.ordenForm.get('costoMonto')?.value;

    // 🌟 2. VALIDACIÓN ESTRICTA: SI ES ESPECÍFICO, TIENE QUE SER MAYOR A 0
    if (modalidad === 'ESPECIFICO') {
      if (monto === null || monto === undefined || monto <= 0) {

        // Forzamos el estado visual de error en el input
        this.ordenForm.get('costoMonto')?.setErrors({ 'invalidCosto': true });
        this.ordenForm.get('costoMonto')?.markAllAsTouched();

        this.toastService.showDanger(
          'Monto Inválido', 
          'Para la modalidad de Costo Específico, el monto debe ser obligatoriamente un valor mayor a \$0.00.'
        );
        //this.ordenForm.get('costoMonto')?.markAsTouched();

        // Hacemos scroll suave hasta el input de costo para que el asesor lo vea de inmediato
        setTimeout(() => {
          const inputCosto = document.querySelector('input[formControlName="costoMonto"]');
          if (inputCosto) {
            inputCosto.scrollIntoView({ behavior: 'smooth', block: 'center' });
            (inputCosto as HTMLElement).focus();
          }
        }, 50);

        this.cdr.detectChanges();

        return; // ⛔ DETIENE EL GUARDADO DE INMEDIATO
      }
    }

    // 🌟 3. CONTINUACIÓN DEL FLUJO NORMAL DE VALIDACIÓN DEL FORMULARIO    
    if (this.ordenForm.valid) {    
      // getRawValue() extrae de forma automática customer: { an8 } y unidad: { id }
      const ordenRaw = this.ordenForm.getRawValue();
      // =========================================================================
      // 💡 CORRECCIÓN CRÍTICA DE IDENTIDAD (EVITA EL ERROR 400 EN SPRING BOOT)
      // =========================================================================
      const idAsesorNum = ordenRaw.id_asesor;      

      // 🌟 MAPEO OPTIMIZADO A ENTEROS NATIVOS (0, 1, 2, 3)
      let codigoModalidad = 0; // Por defecto 0 = GRATIS
      if (ordenRaw.modalidadCosto === 'FIJO') codigoModalidad = 1;
      if (ordenRaw.modalidadCosto === 'VARIABLE') codigoModalidad = 2;
      if (ordenRaw.modalidadCosto === 'ESPECIFICO') codigoModalidad = 3;

      // Asegurar que el monto conserve sus decimales nativos puros
      const montoDecimal = codigoModalidad === 3 ? parseFloat(ordenRaw.costoMonto) : 0.00;

      const orden: any = {
        folio: ordenRaw.folio,
        fecha_entrada: ordenRaw.fecha_entrada,
        customer: ordenRaw.customer,                 // Envía { an8: number }
        unidad: ordenRaw.unidad,                     // Envía { id: number }
        kilometraje: ordenRaw.kilometraje,
        nivelCombustible: ordenRaw.nivelCombustible,
        observaciones_generales: ordenRaw.observaciones_generales?.toUpperCase(),
        
        // 🚀 EL FIX RELACIONAL: Mapeado al objeto 'idAsesor' que espera Java
        idAsesor: { an8: idAsesorNum }, 
        // 🟢 SELLA EL STRING INMUNE OBLIGATORIO
        tipoSilueta: ordenRaw.tipoSilueta || 'Sedán', 
 
        // 🌟 ENVIAR AL BACKEND (Adapta la propiedad al nombre exacto de tu DTO de Spring)
        modalidadCosto: codigoModalidad, 
        //costoMonto: codigoModalidad === 3 ? ordenRaw.costoMonto : 0, 
        costoMonto: montoDecimal, // Mantiene el punto decimal nativo (Ej: 250.75)

        detalles: ordenRaw.detalles,
        sintomas: ordenRaw.sintomas,
        detallesCarroceria: this.pinesCarroceria,   // Coordenadas fijas en %
        fotos: [],
        firma: null
      };

      console.log('Despachando Orden Reactiva a Ecosistema AN8:', orden);

      // Despacho a través de FormData multiparte
      this.recepcionesService.createRecepciones(orden, this.archivosSeleccionados).subscribe({
        next: (resp: any) => {
          // 🚀 REDIRECCIÓN MÓDULO RECEPCIONES
          this.router.navigate(['/recepciones'], {
            state: {
              mostrarAlertaExito: true,
              mensajeToast: `La orden de recepción vehicular ha sido asentada con éxito en la rampa.`
            }
          });                   
        },
        error: (err) => {
          console.error('Error crítico al persistir orden en el servidor:', err);
          // 🌟 REEMPLAZADO: Alerta flotante roja capturando el mensaje nativo de tu API de Java
          this.toastService.showDanger(
            'Error de Servidor', 
            err.error || 'No se pudo establecer conexión con el módulo de órdenes de recepción. Intente de nuevo.'
          );
          this.cdr.detectChanges();
        }
      });
    } else {
      //alert('Por favor, llena todos los campos obligatorios y revisa las alertas en rojo del formulario.');

      // Forzamos a que todo el cabecero de la orden se marque como interactuado
      this.ordenForm.markAllAsTouched(); 
      
      // RECORRIDO DE SUB-TABLAS: Forzamos a que las filas dinámicas de fallas e inventario se iluminen
      this.sintomas.controls.forEach(control => control.markAllAsTouched());
      this.detalles.controls.forEach(control => control.markAllAsTouched());

      // Lanzamos la alerta flotante de bloqueo (Toast) en la esquina de la pantalla
      this.toastService.showDanger(
        'Formulario Incompleto', 
        'Por favor, revise los campos marcados en rojo. Existen datos obligatorios o pertenencias sin evaluar.'
      );

      // DESPLAZAMIENTO SUAVE DE PANTALLA: Buscamos el primer control con error visual de Bootstrap o Material
      setTimeout(() => {
        const primerError = document.querySelector('.is-invalid, mat-error');
        if (primerError) {
          primerError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 50);

      this.cdr.detectChanges();
      return; // Detiene la ejecución aquí para que el JSON erróneo no viaje a tu API de Java      
    }
  }

  // =========================================================================
  // CATÁLOGOS ESTÁTICOS AGRUPADOS (PRODUCTOS / PERTENENCIAS)
  // =========================================================================
  productosAgrupados = [
  {
    categoria: 'Inventario de Pertenencias y Accesorios',
    opciones: [
      { id: 'Llanta de refacción', nombre: 'Llanta de refacción' },
      { id: 'Gato hidráulico', nombre: 'Gato hidráulico' },
      { id: 'Maneral', nombre: 'Maneral' },
      { id: 'Llave de cruz', nombre: 'Llave de cruz' },
      { id: 'Llave para automóvil', nombre: 'Llave para automóvil' },
      { id: 'Control remoto (Alarma/Portón/Cochera)', nombre: 'Control remoto (Alarma - Portón - Cochera)' },
      { id: 'Cables pasa corriente', nombre: 'Cables pasa corriente' },
      { id: 'Kit de herramientas básicas', nombre: 'Kit de herramientas básicas' },
      { id: 'Estuche de dados - autocle', nombre: 'Estuche de dados - autocle' },
      { id: 'Triángulos de seguridad (reflejantes)', nombre: 'Triángulos de seguridad (reflejantes)' },
      { id: 'Extintor', nombre: 'Extintor' },
      { id: 'Botiquín de primeros auxilios', nombre: 'Botiquín de primeros auxilios' },
      { id: 'Autoestéreo - Pantalla central', nombre: 'Autoestéreo - Pantalla central' },
      { id: 'Estéreo o pantalla desmontable', nombre: 'Estéreo o pantalla desmontable' },
      { id: 'Bocinas - Amplificador - Subwoofer', nombre: 'Bocinas - Amplificador - Subwoofer' },
      { id: 'Tapetes - Alfombras', nombre: 'Tapetes - Alfombras' },
      { id: 'Encendedor de cigarros - Adaptador USB', nombre: 'Encendedor de cigarros - Adaptador USB' },
      { id: 'Soporte para teléfono celular - imán', nombre: 'Soporte para teléfono celular - imán' },
      { id: 'Manual del usuario - Carnet de servicios', nombre: 'Manual del usuario - Carnet de servicios' },
      { id: 'Tarjeta de circulación - Documentos', nombre: 'Tarjeta de circulación - Documentos' },
      { id: 'Tag de peaje (Pase/Televía)', nombre: 'Tag de peaje (Pase/Televía)' },
      { id: 'Sombrilla - Paraguas', nombre: 'Sombrilla - Paraguas' },
      { id: 'Documentos en la guantera', nombre: 'Documentos en la guantera' },
      { id: 'Antena', nombre: 'Antena' },
      { id: 'Tapones de ruedas', nombre: 'Tapones de ruedas' },
      { id: 'Objetos personales olvidados', nombre: 'Objetos personales olvidados' }
    ]
  },
  {
    categoria: 'Estado Físico de la Carrocería (Inspección Visual)',
    opciones: [
      { id: 'Defensa delantera - Fascia', nombre: 'Defensa delantera - Fascia' },
      { id: 'Defensa trasera - Fascia', nombre: 'Defensa trasera - Fascia' },
      { id: 'Cofre', nombre: 'Cofre' },
      { id: 'Toldo - Techo', nombre: 'Toldo - Techo' },
      { id: 'Quemacocos - Techo panorámico', nombre: 'Quemacocos - Techo panorámico' },
      { id: 'Cajuela - Quinta puerta', nombre: 'Cajuela - Quinta puerta' },
      { id: 'Salpicadera delantera izquierda', nombre: 'Salpicadera delantera izquierda' },
      { id: 'Salpicadera delantera derecha', nombre: 'Salpicadera delantera derecha' },
      { id: 'Puerta delantera izquierda (Piloto)', nombre: 'Puerta delantera izquierda (Piloto)' },
      { id: 'Puerta trasera izquierda', nombre: 'Puerta trasera izquierda' },
      { id: 'Puerta delantera derecha (Copiloto)', nombre: 'Puerta delantera derecha (Copiloto)' },
      { id: 'Puerta trasera derecha', nombre: 'Puerta trasera derecha' },
      { id: 'Costado - Lateral trasero izquierdo', nombre: 'Costado - Lateral trasero izquierdo' },
      { id: 'Costado - Lateral trasero derecho', nombre: 'Costado - Lateral trasero derecho' },
      { id: 'Espejo retrovisor exterior izquierdo', nombre: 'Espejo retrovisor exterior izquierdo' },
      { id: 'Espejo retrovisor exterior derecho', nombre: 'Espejo retrovisor exterior derecho' },
      { id: 'Parabrisas (Cristal delantero)', nombre: 'Parabrisas (Cristal delantero)' },
      { id: 'Medallón (Cristal trasero)', nombre: 'Medallón (Cristal trasero)' },
      { id: 'Cristales de puertas - Laterales', nombre: 'Cristales de puertas - Laterales' },
      { id: 'Faros principales delanteros', nombre: 'Faros principales delanteros' },
      { id: 'Calaveras - Luces traseras', nombre: 'Calaveras - Luces traseras' },
      { id: 'Luces auxiliares - Faros de niebla', nombre: 'Luces auxiliares - Faros de niebla' },
      { id: 'Parrilla frontal y emblemas', nombre: 'Parrilla frontal y emblemas' },
      { id: 'Molduras laterales - Estribos', nombre: 'Molduras laterales - Estribos' },
      { id: 'Tolvas inferiores - Salpicaderas internas', nombre: 'Tolvas inferiores - Salpicaderas internas' },
      { id: 'Tapón de depósito de gasolina', nombre: 'Tapón de depósito de gasolina' },
      { id: 'Plumas limpiaparabrisas (Estado físico hule)', nombre: 'Plumas limpiaparabrisas (Estado físico hule)' },
      { id: 'Rines - Tapones de ruedas', nombre: 'Rines - Tapones de ruedas' },
      { id: 'Llantas (Estado visual exterior)', field: 'Llantas (Estado visual exterior)', nombre: 'Llantas (Estado visual exterior)' },
      { id: 'Antena de radio', nombre: 'Antena de radio' }
    ]
  },
  {
    categoria: 'Condiciones Mecánicas y Testigos',
    opciones: [
      { id: 'Testigo: Check Engine - MIL', nombre: 'Testigo: Check Engine - MIL' },
      { id: 'Testigo: Presión de Aceite', nombre: 'Testigo: Presión de Aceite' },
      { id: 'Testigo: Temperatura Motor', nombre: 'Testigo: Temperatura Motor' },
      { id: 'Testigo: Sistema ABS - Frenos', nombre: 'Testigo: Sistema ABS - Frenos' },
      { id: 'Testigo: Bolsas de Aire (Airbag)', nombre: 'Testigo: Bolsas de Aire (Airbag)' },
      { id: 'Testigo: Batería - Alternador', nombre: 'Testigo: Batería - Alternador' },
      { id: 'Testigo: TPMS (Presión de llantas)', nombre: 'Testigo: TPMS (Presión de llantas)' },
      { id: 'Testigo: Dirección Asistida (EPS)', nombre: 'Testigo: Dirección Asistida (EPS)' },
      { id: 'Testigo: Control de Estabilidad - Tracción (ESP - TCS)', nombre: 'Testigo: Control de Estabilidad - Tracción (ESP - TCS)' },
      { id: 'Testigo: Freno de mano - Líquido bajo', nombre: 'Testigo: Freno de mano - Líquido bajo' },
      { id: 'Nivel de Aceite de Motor', nombre: 'Nivel de Aceite de Motor' },
      { id: 'Nivel de Líquido de Frenos', nombre: 'Nivel de Líquido de Frenos' },
      { id: 'Nivel de Líquido Refrigerante (Anticongelante)', nombre: 'Nivel de Líquido Refrigerante (Anticongelante)' },
      { id: 'Líquido de Dirección Hidráulica', nombre: 'Líquido de Dirección Hidráulica' },
      { id: 'Nivel de Líquido Limpiaparabrisas', nombre: 'Nivel de Líquido Limpiaparabrisas' },
      { id: 'Estado de la Batería (Físico - Bornes)', nombre: 'Estado de la Batería (Físico - Bornes)' },
      { id: 'Bandas de accesorios (Motor)', nombre: 'Bandas de accesorios (Motor)' },
      { id: 'Fugas visibles de fluidos (Motor - Piso)', nombre: 'Fugas visibles de fluidos (Motor - Piso)' },
      { id: 'Pedal de freno (Sensación)', nombre: 'Pedal de freno (Sensación)' },
      { id: 'Pedal de embrague - Cloche', nombre: 'Pedal de embrague - Cloche' },
      { id: 'Palanca de velocidades - Respuesta transmisión', nombre: 'Palanca de velocidades - Respuesta transmisión' },
      { id: 'Dirección (Vibración o jaloneo)', nombre: 'Dirección (Vibración o jaloneo)' },
      { id: 'Aire Acondicionado - Calefacción', nombre: 'Aire Acondicionado - Calefacción' },
      { id: 'Limpiaparabrisas (Mecanismo electrónico)', nombre: 'Limpiaparabrisas (Mecanismo electrónico)' },
      { id: 'Elevadores de cristales - Seguros eléctricos', nombre: 'Elevadores de cristales - Seguros eléctricos' },
      { id: 'Luces e iluminación general (Altas - Bajas - Stop)', nombre: 'Luces e iluminación general (Altas - Bajas - Stop)' },
      { id: 'Emisión de humo por escape (Visual)', nombre: 'Emisión de humo por escape (Visual)' },
      { id: 'Ruidos extraños en marcha - Motor', nombre: 'Ruidos extraños en marcha - Motor' }
    ]
  }
];

// =========================================================================
// VALIDACIÓN INTERNA DINÁMICA Y GESTIÓN DE CANVAS / CROQUIS
// =========================================================================
	evaluarValidacionComentario(index: number): void {
		const filaForm = this.detalles.at(index);
		if (!filaForm) return;
		const itemNombre = filaForm.get('item_nombre')?.value;
		const comentarioCtrl = filaForm.get('comentario_especifico');
		if (itemNombre === 'OTROS') {
			comentarioCtrl?.setValidators([Validators.required]);
			comentarioCtrl?.markAsTouched();
		} else {
			comentarioCtrl?.clearValidators();
			comentarioCtrl?.markAsUntouched();
		}
		comentarioCtrl?.updateValueAndValidity();
	}


  onCroquisClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    
    // 🔍 LOG DE CONTROL: Abre tu consola (F12) y haz clic en el auto para ver si responde
    console.log('Clic detectado en el elemento:', target.tagName, 'Clases:', target.className);

    // SEGUROS DE FILTRADO: Solo cancelamos el clic si diste EXACTAMENTE en un botón o input del menú
    if (target.tagName === 'BUTTON' || target.tagName === 'INPUT' || target.tagName === 'SELECT') {
      return;
    }

    // Si diste clic en un pin existente, detenemos la propagación para que se borre y no abra el menú
    if (target.classList.contains('croquis-pin')) {
      event.stopPropagation();
      return;
    }

    const container = event.currentTarget as HTMLElement;
    const rect = container.getBoundingClientRect();
    
    const clickX = event.clientX - rect.left;
    const clickY = event.clientY - rect.top;

    // 1. Guardamos el porcentaje exacto para MySQL
    this.coordenadasTemporales = {
      x: (clickX / rect.width) * 100,
      y: (clickY / rect.height) * 100
    };

    // 2. Posición fija en pantalla de la tarjeta flotante
    this.posicionPantallaMenu = {
      left: event.clientX + 10,
      top: event.clientY + 10
    };

    // 3. Activamos el interruptor visual
    this.comentarioTemporal = '';
    this.mostrarMenuFlotante = true;
    
    console.log('Menú flotante activado en %:', this.coordenadasTemporales);
    console.log('Posición en pantalla px:', this.posicionPantallaMenu);
  }

  
	removerPinCroquis(pinAEliminar: RecepcionCarroceria): void {
		this.pinesCarroceria = this.pinesCarroceria.filter(p => p !== pinAEliminar);
	}

	confirmarDano(tipo: 'RAYON' | 'GOLPE' | 'ROTURA' | 'OXIDO' | 'PICADURA'): void {
		const nuevoPin: RecepcionCarroceria = {
			xPercentage: this.coordenadasTemporales.x,
			yPercentage: this.coordenadasTemporales.y,
			tipoDano: tipo,
			gravedad: 'MEDIA',
			descripcion: this.comentarioTemporal.trim() || 'Detalle visual'
		};
		this.pinesCarroceria.push(nuevoPin);
		this.mostrarMenuFlotante = false;
	}

	cancelarDano(): void {
		this.mostrarMenuFlotante = false;
	}

}
